import styled from "styled-components";

const Container = styled.div`
  display: flex;
  justify-content: flex-start;
  max-width: 300px;
  width: 100%;
  font-family: "Larsseit", "Roboto", sans-serif;
  font-size: 0.75em;
  align-items: stretch;
  height: 40px;
`;

const Link = styled.a`
  display: flex;
  align-items: center;
  color: #898989;
  flex: 1;

  &:hover,
  &.active {
    color: #5f5f5f;
  }
`;

export function NavigationDesktop({ links, active }) {
  return (
    <Container>
      {links.map(({ id, name, url }) => (
        <Link href={url} className={active === url && "active"} key={id}>
          {name}
        </Link>
      ))}
    </Container>
  );
}